import React from 'react';
import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';

function AccessoryConfig({ accessory, accessoryConfig, setAccessory }) {
  const categories = (accessoryConfig || {}).categories || [];

  const onChange = (event) => {
    const { name, value } = event.target;
    setAccessory({ ...accessory, [name]: value });
  };

  const onCheck = (event) => {
    const { name, checked } = event.target;
    setAccessory({ ...accessory, [name]: checked });
  };

  return (
    <div>
      <h4>
        {accessory && accessory.id ? `Edit Accessory` : 'Add New Accessory'}
      </h4>
      <div className="row">
        <div className="form-group col-md-3">
          <label>Name*</label>
          <input
            name="name"
            className="form-control"
            onChange={onChange}
            value={accessory.name || ''}
            required
          />
        </div>
        <div className="form-group col-md-3">
          <label>Part Number*</label>
          <input
            name="partNumber"
            className="form-control"
            onChange={onChange}
            value={accessory.partNumber || ''}
            required
          />
        </div>
        <div className="form-group col-md-3">
          <label>Categories</label>
          <Typeahead
            id="accessory-typeahead"
            className="picker"
            // https://github.com/ericgio/react-bootstrap-typeahead/blob/main/docs/Upgrading.md#v5
            inputProps={{
              shouldSelectHint: (shouldSelect, event) =>
                event.key === 'Enter' || shouldSelect,
            }}
            multiple
            clearButton
            options={categories}
            selected={categories.filter((c) =>
              (accessory.categoryIds || []).includes(c.id),
            )}
            labelKey="name"
            onChange={(selected) => {
              const categoryIds = selected.map((c) => c.id);
              setAccessory({ ...accessory, categoryIds });
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="form-group col-md-3">
          <label>Price*</label>
          <input
            name="price"
            type="number"
            className="form-control"
            onChange={onChange}
            value={accessory.price ?? ''}
            pattern="\d+"
            step="0.01"
            min="0"
            required
          />
        </div>
        <div className="form-group col-md-3">
          <label>Discount</label>
          <input
            name="discount"
            type="number"
            className="form-control"
            onChange={onChange}
            value={accessory.discount ?? ''}
            pattern="\d+"
            step="0.01"
            min="0"
            max="100"
          />
          <i>Percentage of price</i>
        </div>
        <div className="checkbox col-md-2">
          <label>
            <input
              type="checkbox"
              name="enabled"
              checked={accessory.enabled || false}
              onChange={onCheck}
            />
            Enable Accessory
          </label>
        </div>
        <div className="checkbox col-md-2">
          <label>
            <input
              type="checkbox"
              name="taxed"
              checked={accessory.taxed || false}
              onChange={onCheck}
            />
            Taxable
          </label>
        </div>
      </div>
      <div className="row">
        <div className="form-group col-md-10">
          <label>Description</label>
          <textarea
            rows="3"
            name="description"
            className="form-control"
            onChange={onChange}
            value={accessory.description || ''}
          />
        </div>
      </div>
    </div>
  );
}

AccessoryConfig.propTypes = {
  accessory: PropTypes.object,
  accessoryConfig: PropTypes.object,
  setAccessory: PropTypes.func,
};

export default AccessoryConfig;
